import { render, staticRenderFns } from "./CatDetails.vue?vue&type=template&id=7902249c&scoped=true&"
import script from "./CatDetails.vue?vue&type=script&lang=js&"
export * from "./CatDetails.vue?vue&type=script&lang=js&"
import style0 from "./CatDetails.vue?vue&type=style&index=0&id=7902249c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7902249c",
  null
  
)

export default component.exports